import React from 'react';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { Box, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import type { MeatballMenuGroup } from '../dropdown-group/types.tsx';

type Props = { dropdownGroupData: MeatballMenuGroup; onClick: () => void; groupName: string };

const DropdownLayeredGroup = ({ dropdownGroupData: { items }, onClick, groupName }: Props) => {
	return (
		<Box xcss={topBorderStyles}>
			<DropdownMenu
				placement="left-start"
				shouldRenderToParent
				trigger={({ triggerRef, ...triggerProps }) => (
					<DropdownItem
						{...triggerProps}
						ref={triggerRef}
						elemAfter={<ChevronRightIcon primaryColor={token('color.icon.subtle', '')} label="" />}
					>
						<Text>{groupName}</Text>
					</DropdownItem>
				)}
			>
				<DropdownItemGroup>
					{items.map((item, i) => (
						// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
						<div key={i} onClick={onClick}>
							{item}
						</div>
					))}
				</DropdownItemGroup>
			</DropdownMenu>
		</Box>
	);
};

export default DropdownLayeredGroup;

const topBorderStyles = xcss({
	borderTop: `1px solid ${token('color.border')}`,
});
